export const buttonChangeStyle = {
  px: {
    xs: 2,
    sm: 5,
    lg: 5,
  },
  width: "fit-content",
  textTransform: "none",
  fontSize: {
    xs: "medium",
    sm: "large",
    lg: "large",
  },
  borderRadius: 0,
};

export const buttonSubmitStyle = {
  px: 2,
  backgroundColor: "secondary.main",
  color: "black",
  borderRadius: 10,
  width: "fit-content",
  marginInline: "auto",
  ":hover": {
    backgroundColor: "secondary.300",
  },
};

export const formStyle = {
  width: {
    xs: "320px",
    sm: "350px",
    lg: "400px",
  },
};

export const buttonStepsStyle = {
  backgroundColor: "primary.main",
  width: "fit-content",
  color: "white",
  ":hover": {
    backgroundColor: "primary.300",
  },
};

export const inputInvertirStyle = {
  width: {
    xs: "100%",
    sm: 250,
    md: 300,
    lg: 350,
  },
  mb: 2,
};

export const titleInvertStyle = { color: "primary.main", fontWeight: "bold" };

export const gradientColor =
  "linear-gradient(176deg, rgba(0,51,102,1) 0%, rgba(0,102,204,1) 100%)";

export const mainDataHomeText = {
  display: "flex",
  gap: 0.5,
  color: "rgba(0, 42, 66, 0.78)",
  alignItems: "center",
  fontWeight: "normal",
  fontSize: {
    xs: "small",
    md: "small",
    lg: "normal",
    xl: "normal",
  },
};

export const elementDataPropertyCard = {
  fontSize: "small",
  color: "rgba(0, 42, 66, 0.78)",
  alignItems: "center",
  flexDirection: "row",
  gap: 0.4,
};

export const buttonActionNewProject = {
  color: "white",
  backgroundColor: "primary.main",
  "&:hover": {
    backgroundColor: "primary.lighter",
  },
  transition: "background-color .3s",
};
